import React from 'react';
import PropTypes from 'prop-types';
import { getAllParams } from '../../service/utils';

const AccessibilityTable = ({ caption, children, ...params }) => {
    return (
        <table role="presentation" {...getAllParams(params)}>
            <caption>{caption}</caption>
            {children}
        </table>

    );
};

AccessibilityTable.propTypes = window.config.developMode ? {
    caption: PropTypes.string.isRequired
} : {};

export default AccessibilityTable;
